import { render, staticRenderFns } from "./PImage.vue?vue&type=template&id=7dae9254"
import script from "./PImage.vue?vue&type=script&lang=js"
export * from "./PImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports